import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormButtonsComponent } from 'components/form-buttons/form-buttons.component';
import { InputComponent } from 'components/input/input.component';
import { ModalComponent } from 'components/modal/modal.component';
import { Modal, ModalActionType } from 'components/modal/modal.model';
import { CustomValidators } from 'weavix-shared/custom-validators';

@Component({
    selector: 'app-table-folder-delete-modal',
    templateUrl: './table-folder-delete-modal.component.html',
    styleUrls: ['./table-folder-delete-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormButtonsComponent,
        InputComponent,
        ModalComponent,
        TranslateModule,
    ],
})
export class TableFolderDeleteModalComponent implements OnChanges {
    @Input() open = false;
    @Input() folderName: string;
    @Input() entity: string;
    @Input() entityCount = 0;
    @Input() subFolderCount = 0;
    @Output() closed = new EventEmitter<ModalActionType>();

    form: FormGroup<{ folderName: FormControl<string> }>;
    tableFolderDeleteModal: Modal;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.open?.currentValue) {
            this.modalOpen();
        } else {
            this.modalClose();
        }
    }

    modalOpen() {
        this.form = new FormGroup({
            folderName: new FormControl('', [Validators.required, CustomValidators.stringMatch(this.folderName?.toString())]),
        });

        this.tableFolderDeleteModal = {
            isOpen: true,
            actions: {},
            header: {
                textKey: 'table.delete-folder-confirmation.title',
                showSeparator: true,
                textAlignment: 'left',
            },
            params: {
                name: this.folderName,
                entityCount: this.entityCount,
                subFolderCount: this.subFolderCount,
            },
            fullScreen: false,
            content: true,
            width: 600,
        };
    }

    submit() {
        this.closed.next(ModalActionType.submit);
    }

    cancel() {
        this.closed.next(ModalActionType.cancel);
    }

    handleModalClose(action: ModalActionType) {
        this.closed.next(action);
    }

    modalClose() {
        this.tableFolderDeleteModal = null;
        this.closed.emit();
    }
}
